export default '/chart/@id'
